import Search from 'mcs-toolkit/components/Search';
import React from 'react';
import { SearchProps } from 'semantic-ui-react';

import {
    BasicField,
    BasicFieldProps,
} from 'reactApp/components/Forms/_BasicField';

import styles from './FieldSearch.css';

/*
есть warning, который не хотят чинить
https://github.com/Semantic-Org/Semantic-UI-React/issues/1141
 */
export type FieldTextAreaProps = SearchProps & Omit<BasicFieldProps, 'control'>;
export const FieldSearch = ({
    className,
    name,
    dataTest,
    ...otherInputProps
}: FieldTextAreaProps) => {
    return (
        <BasicField
            data-test={dataTest}
            name={name}
            className={className}
            control={renderControl}
            {...otherInputProps}
        />
    );
};

function renderControl({
    onChange,
    noResultsMessage = 'Совпадений не найдено',
    ...props
}: SearchProps) {
    return (
        <Search
            {...props}
            noResultsMessage={
                <span className={styles.noResultsMessage}>
                    {noResultsMessage}
                </span>
            }
            onSearchChange={onChange}
        />
    );
}
